const DAY_MS = 24 * 60 * 60 * 1000;

const formatUtcDate = (date) => date.toISOString().slice(0, 10);

const addUtcDays = (date, days) => new Date(date.getTime() + (days * DAY_MS));

export const getProjectStatisticsPreset = (preset, now = new Date()) => {
  const today = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate()
  ));

  switch (preset) {
    case '7d':
      return { from: formatUtcDate(addUtcDays(today, -6)), to: formatUtcDate(today) };
    case '30d':
      return { from: formatUtcDate(addUtcDays(today, -29)), to: formatUtcDate(today) };
    case 'month':
      return {
        from: formatUtcDate(new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1))),
        to: formatUtcDate(today),
      };
    case 'all':
      return { from: '', to: '' };
    default:
      throw new Error(`Unknown statistics date preset: ${preset}`);
  }
};

export const validateProjectStatisticsRange = ({ from, to }) => {
  if (!from || !to) {
    return 'Choose both From and To dates';
  }
  if (from > to) {
    return 'From date must be on or before To date';
  }
  return null;
};

export const buildProjectStatisticsRangeParams = ({ from, to }) => (
  from && to ? { from, to } : {}
);
